import { History } from "lucide-react";
import { money } from "../api";

export function PriceHistory({ history, currency = "TRY", testid }) {
  if (!history?.length) return null;
  return (
    <div className="price-history" data-testid={testid}>
      <span className="eyebrow"><History size={11} style={{ verticalAlign: "-1px", marginRight: 4 }} />FİYAT GEÇMİŞİ ({history.length})</span>
      {[...history].reverse().map((h, i) => (
        <div className="price-hist-row" key={i}>
          <span className="ph-date">{(h.effective_date || "").slice(0, 10)}</span>
          <span className="ph-change">{money(h.old_amount, currency)} → <b>{money(h.new_amount, currency)}</b></span>
          <span className={h.delta >= 0 ? "ph-delta up" : "ph-delta down"}>
            {h.delta >= 0 ? "+" : ""}{money(h.delta, currency)}{h.percent != null ? ` (${h.percent >= 0 ? "+" : ""}${h.percent}%)` : ""}
          </span>
          <small className="ph-reason">{h.reason || "—"}{h.by ? ` · ${h.by}` : ""}</small>
        </div>
      ))}
    </div>
  );
}
